// Price parsing helper function
export const parsePrice = (priceStr: string): number => {
  if (!priceStr) return 0;
  
  // Remove currency symbols, commas, and spaces
  let cleaned = priceStr.replace(/[^0-9.,]/g, '');
  
  // Handle European number format (1.499,99 -> 1499.99)
  if (cleaned.includes(',') && cleaned.includes('.')) {
    // If both comma and dot exist, assume comma is decimal separator
    cleaned = cleaned.replace(/\./g, '').replace(',', '.');
  } else if (cleaned.includes(',')) {
    // If only comma exists, check if it's a decimal or thousands separator
    const parts = cleaned.split(',');
    if (parts.length === 2 && parts[1].length <= 2) {
      // Likely a decimal separator (e.g., 1,99 -> 1.99)
      cleaned = cleaned.replace(',', '.');
    } else {
      // Likely a thousands separator (e.g., 1,000 -> 1000)
      cleaned = cleaned.replace(/,/g, '');
    }
  }
  
  const num = parseFloat(cleaned);
  return isNaN(num) ? 0 : num;
};

// Format price helper
export const formatPrice = (amount: number, symbol: string = '$'): string => {
  return `${symbol}${amount.toFixed(2)}`;
};